import React, { useContext, useEffect, useState } from "react";
import "./likeNew.scss";
import { Context } from "../../../index";
import { observer } from "mobx-react-lite";
import {
  mindboxAddToWishList,
  mindboxRemoveFromWishList,
} from "../../../http/catalogApi";
import { addFavorite, deleteFavorite } from "../../../http/favoriteApi";
import { ReactComponent as LikeIcon } from "../../../assets/icons/like.svg";

const LikeNew = observer((props) => {
  const { settings } = useContext(Context);
  const [deviceUUID, setDeviceUUID] = useState("");
  const [userAgent, setUserAgent] = useState("");
  const { user } = useContext(Context);

  useEffect(() => {
    setDeviceUUID(
      document.cookie.replace(
        /(?:(?:^|.*;\s*)mindboxDeviceUUID\s*\=\s*([^;]*).*$)|^.*$/,
        "$1"
      )
    );
    setUserAgent(window.navigator.userAgent);
  });

  const checkExistFavoriteProduct = () => {
    let favoriteJson = settings.favoriteArray;
    if (!favoriteJson) {
      return false;
    }

    for (const oneFavorite of favoriteJson) {
      if (props.itemProduct.id === oneFavorite.id) {
        return true;
      }
    }

    return false;
  };

  const addProductFavorite = (object) => {
    //Пустая переменная для хранения товаров в фаворитах
    let currentFavoriteArray = [];
    // Мы получаем с локального стора товары для фаворитов.
    let currentFavoriteStorage = localStorage.getItem("favoriteStorage");

    if (!currentFavoriteStorage) {
      // Если в сторе нету товаров, мы сразу пушим 1 товар, конвертируем его в JSON и записываем в стор.
      currentFavoriteArray.push(object);
      let jsonCurrentFavoriteArray = JSON.stringify(currentFavoriteArray);
      if (user.isAuth) {
        addFavorite(object.id, user.user.id);
      }
        if (window.turboTarget && window.turboTarget.sendRTGMessage) {
            window.turboTargetPixelRTGLikeProduct(object.product.id);
        } else {
            document.addEventListener("generalPixelInited", () => {
                window.turboTargetPixelRTGLikeProduct(object.product.id)
            })
        }
      localStorage.setItem("favoriteStorage", jsonCurrentFavoriteArray);
    } else {
      // Если в сторе уже что-то есть, мы в пустой массиф сохраняем результат получения и депарсинга JSON
      currentFavoriteArray = JSON.parse(currentFavoriteStorage);

      let indexItem = 0;
      let isFind = false;

      for (const oneFavoriteItem of currentFavoriteArray) {
        if (oneFavoriteItem.id === object.id) {
          currentFavoriteArray.splice(indexItem, 1);
          if (user.user.id) {
            deleteFavorite(object.id, user.user.id);
          }
          isFind = true;
        }
        indexItem++;
      }

      if (!isFind) {
        if (user.isAuth) {
          addFavorite(object.id, user.user.id);
        }
        currentFavoriteArray.push(object);
        props.onAddInFavorite && props.onAddInFavorite();
          if (window.turboTarget && window.turboTarget.sendRTGMessage) {
              window.turboTargetPixelRTGLikeProduct(object.product.id);
          } else {
              document.addEventListener("generalPixelInited", () => {
                  window.turboTargetPixelRTGLikeProduct(object.product.id)
              })
          }
      }

      let jsonCurrentFavoriteArray = JSON.stringify(currentFavoriteArray);
      localStorage.setItem("favoriteStorage", jsonCurrentFavoriteArray);

      settings.setFavoriteArray(currentFavoriteArray);
    }
  };

  return (
    <div
      onClick={(e) => {
        e.stopPropagation();
        addProductFavorite(props.itemProduct);
        const sizeId =
          props.itemProduct.child_product_size &&
          props.itemProduct.child_product_size.length
            ? props.itemProduct.child_product_size[0].id
            : props.itemProduct?.child_product_size_field[0].sizeId
            ? props.itemProduct.child_product_size_field[0].sizeId
            : null;

        const currentSize = props.itemProduct.child_product_size?.find(
          (item) => item.id === sizeId
        );
        const guid =
          currentSize?.childProduct_Size?.guid ?? props.itemProduct.id;

        if (sizeId) {
          if (checkExistFavoriteProduct()) {
            mindboxAddToWishList(
              deviceUUID,
              userAgent,
              guid,
              props.itemProduct.parrent_price
            );
          } else {
            mindboxRemoveFromWishList(
              deviceUUID,
              userAgent,
              guid,
              props.itemProduct.parrent_price
            );
          }
        }
      }}
      className={
        checkExistFavoriteProduct() ? "like_wrapper active" : "like_wrapper"
      }
    >
      <LikeIcon />
    </div>
  );
});

export default LikeNew;
